module.exports = __webpack_public_path__ + "img/btn02.5b6f7439.svg";